const patientSmartPlanBuilder = {
  suggestionButton: "Suggest products",
  viewSuggestedProducts: "View suggested products",
  smartBuilder: " ",
  betaToolTip: "This feature is in beta. Expect updates as we refine it to better suit your needs.",
  disclaimer:
    "Recommendations generated by advanced intelligence: Efforts have been made to ensure accuracy and relevance of information, but users should verify before making decisions.",
  reviewPatientDetails: "Review {{patientTerm}} details",
  reviewPatientDetailsDescription:
    "Modify or add {{patientTerm}} details to calculate the best ingredients for your {{patientTerm}}.",
  selectYourProducts: "Select your products",
  noProductsFoundTitle: "No products found for {{ingredient}} ingredient",
  noProductsFoundDescription: "We're unable to find a product match for the dosage you set.",
  searchCatalog: "Search catalog",
  smartSuggestionStepDescription:
    "Based on your ingredient selection(s), here are some products you can select and add to {{patientName}}'s plan.",
  yourSelectedIngredients: "Your selected ingredient",
  reviewDetails: "Review details",
  recalculateModal: {
    title: "Start over?",
    description: "You will lose all ingredients and inputs.",
    keepWorking: "Keep working",
    confirm: "Confirm",
  },
  missingDosageModal: {
    title: "Missing dosage amount",
    description: "All ingredients must have a dosage amount to proceed.",
  },
  step2: {
    confirmPatientInputs: "Confirm {{patientTerm}} inputs",
    refineIngredients: "Refine ingredients",
    ModifyOrAddIngredients: "Modify or add ingredients",
    SelectProducts: "Select products",
    AddProductsToPlan: "Add products to plan",
    refineIngredientsDescription:
      "Modify the ingredients and dosage amounts using your professional judgement.",
    noIngredient: "No ingredient suggestions",
    noIngredientDescription:
      "There are no ingredients available for the inputs you provided. Add your own ingredients to get started.",
    ingredient: "Ingredient",
    dosageUnits: "Dosage (units per day)",
    indication: "Indication",
    generatedByAI:
      "This content was generated by AI software. Efforts have been made to ensure accuracy and relevance, but users should verify before making decisions.",
    dosage: "dosage",
    deleteModal: {
      title: "Remove {{ingredientName}}?",
      description:
        "Confirm removing this ingredient from the list. It can be added back to the list.",
      remove: "Remove",
      cancel: "Cancel",
    },
    ingredientAddedSuccess: "Ingredient added successfully",
    ingredientRemovedSuccess: "Ingredient removed successfully",
    FailedToAddIngredient: "Failed to add ingredient",
  },
  step3: {
    tooltipText: {
      currentlyTaking: "Your {{patientTerm}} is currently taking this product.",
      pastPlan: "Your {{patientTerm}} has taken this product in the past.",
      yourFavorite: "This product is part of your favorites.",
      frequentlyRecommended: "You use this product multiple times in your sent plans.",
    },
  },
  demographics: "Demographics",
  demographicsDescription:
    "Demographic information is used to improve suggestions for other inputs. <2>Learn more</2>",
  noDemographicsData: "No demographic data available",
  noDemographicsDataDescription:
    "Your {{patientTerm}}'s age and sex help refine ingredient suggestions. You can add this information on their profile.",
  healthAreas: "Health areas",
  healthAreasDescription:
    "Health areas are used to generate ingredient suggestions. <2>Learn more</2>",
  noHealthAreas: "No health areas available",
  addHealthAreas: "Add health areas",
  addHealthAreasModal: {
    body: "Search conditions or symptoms and select the applicable health areas to generate ingredient suggestions.",
    totalConditions: "{{count}} condition",
    totalConditions_plural: "{{count}} conditions",
    searchConditions: "Search conditions or symptoms",
    noHealthAreas: "No suggested health areas",
    totalHealthAreas: "{{count}} suggested health area",
    totalHealthAreas_plural: "{{count}} suggested health areas",
  },
  activePlanProductsMissingIngredients:
    "The following products won't be included in generating suggestions due to lack of ingredient data: {{productNames}}",
  noHealthAreasDescription:
    "Add health areas to improve ingredient suggestions. This data won't be added to your {{patientTerm}}'s profile.",
  supplements: "Supplements",
  supplementsDescription:
    "Supplements your {{patientTerm}} is currently taking are used to improve suggestions for other inputs. <2>Learn more</2>",
  noSupplements: "{{patientName}} hasn't added any products",
  noSupplementsDescription:
    "The supplements that {{patientName}} is currently taking can help with improved suggestions. <2>Learn more about currently taking</2>",
  numProduct: "{{count}} product",
  numProduct_plural: "{{count}} products",
  medications: "Medications",
  medicationsDescription:
    "Medications your {{patientTerm}} is currently taking are used to generate ingredient suggestions. <2>Learn more</2>",
  noMedications: "{{patientName}} hasn't added any medications",
  noMedicationsDescription:
    "The medications that {{patientName}} is currently taking are used to power ingredient suggestions related to depletions and interactions. <2>Learn more about currently taking</2>",
  noMedicationsAddedManually: "No medications added manually",
  addMedications: "Add medications",
  addMedicationsModal: {
    body: "Search and add medications to generate ingredient suggestions related to depletions and interactions.",
    totalMedications: "{{count}} medication",
    totalMedications_plural: "{{count}} medications",
  },
  includeInSuggestions: "Include in suggestions",
  clearAll: "Clear all",
  medicationsDisclaimer:
    "Disclaimer: This checker finds which nutrients might be depleted by prescription or over-the-counter medications. Each nutrient depletion issue is rated based on clinical significance. Use your own professional judgment prior to making clinical decisions.",
  medicationsDisclaimerCopyright: "© 2023 Therapeutic Research Center, LLC",
  noMedicationsAddedManuallyDescription:
    "Add medications your {{patientTerm}} is taking to generate ingredient suggestions. This data won't be added to your {{patientTerm}}'s profile.",
  searchMedications: "Search medications",
  currentlyTakingRequestSent: "Currently taking request sent",
  currentlyTakingRequestSentDescription:
    "{{patientName}} has received the request to update their currently taking and you'll be notified when they update it.  <2>Learn more about currently taking</2>",
  diagnostics: "Diagnostics",
  diagnosticsDescription:
    "Out of range or suboptimal biomarkers from your {{patientTerm}}'s labs on Fullscript are used to generate ingredient suggestions. <2>Learn more</2>",
  noLabsData: "No labs data available",
  noLabsDataDescription:
    "Use biomarkers that aren't optimal to improve ingredient suggestions. <1>Learn more about labs on Fullscript</1>",
  noLabsInLastThreeMonths: "No available labs within past 3 months",
  noLabsInLastThreeMonthsDescription:
    "Biomarkers that aren't optimal within the last 3 months are used to improve ingredient suggestions. <1>Learn more about labs on Fullscript</1>",
  allBiomarkersOptimal: "All biomarkers are optimal",
  allBiomarkersOptimalDescription:
    "Your {{patientTerm}}'s lab markers are all at optimal levels, so we haven't included the results in our ingredient suggestions.",
  noIngredientSuggestions: "No ingredient suggestions",
  ageAndSex: "{{age}} year old, {{sex}}",
  ageYearOld: "{{age}} years old",
  evidenceLink: "See evidence",
  otherIngredients: "Other ingredients related to this health area:",
  noRecommendedIngredientsForInput:
    "There are no ingredients to recommend for {{input}}. It'll be used to improve the suggestions for other inputs. <1>Learn more</1>",
  updatedAt: "Updated {{date}}",
  testedAt: "Tested {{date}}",
  demographicsAriaLabel: "select-demographics",
  healthAreaAriaLabel: "select-health-area",
  supplementsAriaLabel: "select-supplements",
  medicationsAriaLabel: "select-medication",
  diagnosticsAriaLabel: "select-biomarker",
  oneTimeInputs: "One-time inputs",
  oneTimeInputsTooltip: "These inputs will not be added to your {{patientTerm}}'s profile.",
  reviewPlan: "Review plan",
  startOver: "Start over",
  calculatingIngredients: "Calculating ingredients...",
  findingProducts: "Finding products...",
  viewAllCount: "View all {{ count }}",
  includeAllCount: "Include all ({{ count }})",
  evidenceModal: {
    title: "Evidence",
    descriptionMeds:
      "Use of {{- medicationName}} is associated with decreased levels of {{- ingredientName }}. ",
    descriptionLab:
      "{{patientTermCapitalized}}'s {{- conditionName}} levels are {{label}} and {{- ingredientName }} has been linked in research to supporting optimal {{- conditionName}} levels. ",
    descriptionHealth:
      "{{- ingredientName }} has been linked in research with {{- conditionName }}. ",
    recommendedDose:
      "The recommended dose in prevailing research is {{dosage}} {{unit}} of {{- ingredientName }} per day. ",
    general: "General",
    disclaimer:
      "These articles are curated from a range of internal and external peer reviewed medical sources. <1>Learn more about how results are ranked</>",
    article: "article",
    article_plural: "articles",
    demographicsCategory: {
      female: "Female Adult",
      male: "Male Adult",
    },
  },
  startTile: {
    firstTime: {
      title: "Be the first to try the plan-writing assistant",
      description:
        "Instantly analyze {{patientTerm}} data to address depletions, avoid contraindications and generate ingredient suggestions.",
      patientSelected: {
        buttonText: "Try it for {{patientName}}'s plan",
      },
      noPatientSelected: {
        buttonText: "Try it for a {{patientTerm}} plan",
      },
    },
    returning: {
      title: "Save time writing whole person plans",
      description:
        "Use the plan-writing assistant to build more data-driven {{patientTerm}} plans in less time. Review suggestions, refine, and send.",
      patientSelected: {
        buttonText: "Use it for {{patientName}}'s plan",
      },
      noPatientSelected: {
        buttonText: "Use it for a {{patientTerm}} plan",
      },
    },
    productsSuggested: {
      title: "Continue using plan-writing assistant",
      description:
        "Finish building your customized plan. Choose from your suggested products to send it in seconds. ",
      buttonText: "View suggestions",
    },
    learnMore: "Learn more",
    tooltipForSelectPatient: "Select a {{ patientTerm }} to continue.",
    tooltipForIndividualPlan:
      "This feature is only available for individual {{patientTerm}} plans.",
  },
  legalAgreement: {
    acknowledgment: "Acknowledgment",
    content:
      "By clicking this box you acknowledge and agree that this feature is intended to support healthcare professionals in their clinical decision-making processes. You will only use this feature within the parameters of your licensure, authorizations, and all applicable scope of practice laws, rules, and guidances. Content is provided for information purposes only and does not replace your own judgment or clinical decision making, and it is not a substitute for medical care or for seeing or obtaining advice from a healthcare professional. Do not use for medical emergency services. While we work to ensure that content is correct, we can't guarantee that content is correct, complete or current. You are solely responsible for your use of this feature, including any and all output.",
    buttonText: "Try it now",
  },
  betaBadgeTooltip:
    "This feature is in beta. Expect updates as we refine it to better suit your needs.",
} as const;

export { patientSmartPlanBuilder };
